<template>
  <v-row align="center">
    <v-col class="pb-0">
      <v-card outlined>
        <v-card-text class="py-3">
          <v-row align="center">
            <v-col cols="5" align="left">
              {{ user.name }}
            </v-col>

            <v-col cols="3" align="center">
              {{ user.roles[0] }}
            </v-col>

            <!-- User wiki is hidden for now -->
            <!-- <v-col cols="2" align="center">
              <v-dialog v-model="dialog" width="500">
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" text small v-on="on">
                    Show
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title class="pa-2">
                    <v-btn
                      color="secondary"
                      :href="user.wiki"
                      target="_blank"
                      style="text-transform: none;"
                      text
                    >
                      {{ user.wiki }}
                    </v-btn>
                  </v-card-title>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small text @click="dialog = false">close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col> -->

            <v-col cols="3" align="center">
              <v-dialog v-model="dialog" width="500">
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" text small v-on="on">
                    Show ({{ user.tasks ? user.tasks.length : 0 }})
                  </v-btn>
                </template>

                <v-card class="pt-5">
                  <v-card-text>
                    <div
                      v-for="task in user.tasks"
                      :key="task.id"
                      class="subtitle-2"
                    >
                      {{ task.title }}
                    </div>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small text @click="dialog = false">close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>

            <v-col cols="1" align="right" v-if="$can('users.delete')">
              <v-btn icon @click="confirmDelete">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import { alertConfirm } from '@/utilities/sweetalert'

export default {
  name: 'UsersTableItem',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    ...mapActions('users', ['deleteUser']),
    confirmDelete() {
      alertConfirm(
        {
          title: `Are you sure you want to delete ${this.user.name} user account?`
        },
        () => this.deleteUser(this.user.id)
      )
    }
  }
}
</script>
